// 'use strict',
// 'use strict',
export var environment = {
    // uso de remoteConfig:
    // Si la prop existe puede tener 2 valores:
    // 1) 'self': le indica a iol que genere una url que apunta a su propio backend/proxy/balanceador, 
    //   en el cual existe un restful que le retorna los valores de las propiedades (json)
    // 2) <url>: una URI que apunta a un restful que retorna los valores de las propiedades
    //
    // ** Si el JSON (propiedades) contiene a su vez la propiedad "remoteConfig", 
    //   iol-ui asume que es una redirección y vuelve a invocar el restful pero con la nueva url, 
    //   sirve por ejemplo para que las UI apunten a sus SERVICES por la configuración, 
    //   indicando en todos los casos la config mínima en angular: 
    //     { remoteConfig:'self', kcdevmode:true }
    //
    //remoteConfig: 'http://192.168.0.32:8081/iurix-services/api/env/'
    remoteConfig: 'self'
    // kcdevmode: false,
    // desarrollo: true,
    // local_data: true,
    // services_url: 'http://192.168.40.37:8081/iurix-services/api/',
    // firma_simulada: true,
    // kcRealm: 'iolsanluis',
    // checkDoubleInic: true,
    // checkDoubleInicM: true,
    // timeout: 30, // en minutos
    // useRecaptcha: false,
    // data_sitekey: '6LfgzxsUAAAAALcU8NAn9jr8YUiUIEs0Z9YW79MG',
    // CANT_APERTURAS_EXP: 5,
    // CANT_MINUTOS_EXP: 10,
    // CANT_CAPTCHA_EXP: 5,
    // CANT_APERTURAS_ACT: 5,
    // CANT_MINUTOS_ACT: 10,
    // CANT_CAPTCHA_ACT: 5,
    // CATCHA_MAIL_ASUNTO: 'Recaptcha',
    // CATCHA_MAIL_MENS_EXP: 'Desde los expedientes',
    // CATCHA_MAIL_MENS_ACT: 'Desde las actuaciones',
    // TEXTO_TASA: 'Ley Imp Anual Eje. Fiscal 2017',
    // LINK_TASA: 'http://www.google.com.ar',
    // version: '4.1.1',
    // botonComp: true
};
//# sourceMappingURL=environment.js.map